// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","row":"row--298dd"};